module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "About-the-Author.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("All about the author…")]), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Kate Hewitt")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("KATE HEWITT")]), _vm._v(" discovered her first Harlequin® romance novel on a trip to England when she was thirteen, and she’s continued to read them ever since. She wrote her first story at the age of five, simply because her older brother had written one and she thought she could do it, too. That story was one sentence long—fortunately, they’ve become a bit more detailed as she’s grown older.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("She studied drama in college and shortly after graduation moved to New York City to pursue a career in theater. This was derailed by something far better—meeting the man of her dreams, who happened also to be her older brother’s childhood friend. Ten days after their wedding they moved to England, where Kate worked a variety of different jobs—drama teacher, editorial assistant, youth worker, secretary and, finally, mother.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("When her oldest daughter was one year old, Kate sold her first short story to a British magazine. Since then she has sold many stories and serials, but writing romance remains her first love—of course!")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Besides writing, she enjoys reading, traveling and learning to knit—it’s an ongoing process and she’s made a lot of scarves. After living in England for six years, she now resides in Connecticut with her husband, her three young children and, possibly one day, a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("Kate loves to hear from readers. You can contact her through her website, "), _c('a', {
    attrs: {
      "href": "http://www.kate-hewitt.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlink"
  }, [_vm._v("www.kate-hewitt.com")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('br'), _vm._v("Other titles by Kate Hewitt available in ebook:")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_c('br'), _vm._v("AN INHERITANCE OF SHAME "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Sicily’s Corretti Dynasty")]), _vm._v(")"), _c('br'), _vm._v("HIS BRAND OF PASSION "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Bryants: Powerful & Proud)")]), _c('br'), _vm._v("IN THE HEAT OF THE SPOTLIGHT "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Bryants: Powerful & Proud)")]), _c('br'), _vm._v("BENEATH THE VEIL OF PARADISE "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Bryants: Powerful & Proud)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58425681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AbouttheAuthor.vue
// module id = 72
// module chunks = 0